module.exports = __webpack_public_path__ + "static/media/pods_tablets_dark.ec8f22af.png";